import styled from "styled-components";

export const MedicineCardContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
export const MedicineCardWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0.5rem;
  border-radius: 0.5rem;
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  border: ${(props) =>
    props.checked ? "1px solid #22b573" : "1px solid #d5d5d5"};
  overflow: hidden;
  background: ${(props) => (props.checked ? "#22b5730a" : "#fff")};
  box-shadow: ${(props) =>
    props.checked ? "0px 0px 2px -1px #22b5735e" : "none"};
`;

export const MedicineCardFloatingWrapper = styled.div`
  .status {
    background-color: rebeccapurple;
    color: white;
    padding: 5px 15px;
    border-radius: 0 0 0 0.5rem;
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5em;
    text-wrap: nowrap;

    svg {
      font-size: 14px;
    }
  }
  .edit {
    position: absolute;
    right: 15px;
    align-items: center;
    display: flex;
    top: 0;
    bottom: 0px;
    cursor: pointer;
  }
`;

export const MedicineCardTopWrapper = styled.div`
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  .status {
    min-height: 35px;
  }
  .bactchWrapper {
    min-height: 35px;
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 5px 15px;
    background: #eee;
    border-radius: 0 0 0.5em 0;

    .batchLabel {
      font-size: 12px;
      font-weight: 300;
      color: var(--dark);
      letter-spacing: 0.75px;
      text-transform: capitalize;
      text-wrap: nowrap;
    }
    .batchNumber {
      font-weight: 600;
      font-size: 16px;
      color: var(--dark);
      text-transform: uppercase;
      text-wrap: nowrap;
      max-width: 120px;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

export const MedicineCardFixedWrapper = styled.div`
  display: flex;
  gap: 0.75em;
  align-items: flex-start;
  margin-top: 35px;

  .MedicineCardInfo {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    max-width: 80%;
    .medicineWrapper {
      display: flex;
      align-items: center;
      gap: 0.5em;
      .medicineName {
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0.5px;
        color: var(--dark);
        max-width: 250px;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
      }
      .medicineInfo {
        cursor: pointer;
      }
    }

    .medicineQtyWrapper {
      font-size: 12px;
      letter-spacing: 0.5px;
      font-weight: 400;
      color: var(--dark);

      span {
        font-size: 16px;
        font-weight: 600;
        margin: 0 5px;
      }
    }
  }
`;
